import { render, staticRenderFns } from "./IntegradorSettingsList.vue?vue&type=template&id=88345dea"
import script from "./IntegradorSettingsList.vue?vue&type=script&lang=js"
export * from "./IntegradorSettingsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports